import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  ionMailOutline,
  ionTimerOutline,
  ionBusinessOutline,
  ionPersonOutline,
  ionReaderOutline,
  ionLibraryOutline,
} from '@ng-icons/ionicons';
import { MoneyPipe } from 'src/app/shared/pipe/money.pipe';
import { TimeAgoPipe } from 'src/app/shared/pipe/time-ago.pipe';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { JobOfferService } from 'src/app/api/services';
import { JobOfferPostulantService } from 'src/app/api/services/job-offer-postulant.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import {
  JobOfferDetails,
  JobOfferSummary,
} from 'src/app/shared/model/job-offer-detail';
import { MESSAGES } from 'src/app/core/constant/messages';
import { bootstrapSuitcaseLg } from '@ng-icons/bootstrap-icons';
import { heroCheckBadge } from '@ng-icons/heroicons/outline';
import { SolesCurrencyPipe } from 'src/app/shared/pipe/soles-currency.pipe';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { TokenStorageService } from 'src/app/shared/service/token-storage.service';
import { UserStatus } from 'src/app/core/enum/user-status';

@Component({
  selector: 'app-details-job',
  standalone: true,
  imports: [
    CommonModule,
    TimeAgoPipe,
    NgIcon,
    RouterModule,
    SolesCurrencyPipe,
    LoadingButtonComponent,
  ],
  templateUrl: './details-job.component.html',
  styles: ``,
  viewProviders: [
    provideIcons({
      ionMailOutline,
      ionTimerOutline,
      ionBusinessOutline,
      ionPersonOutline,
      bootstrapSuitcaseLg,
      heroCheckBadge,
      ionReaderOutline,
      ionLibraryOutline,
    }),
  ],
})
export class DetailsJobComponent implements OnInit {
  jobDetail?: JobOfferDetails;
  jobOffers: JobOfferSummary[] = [];
  isLoading: boolean = true;
  isLoadingPostulant: boolean = false;
  postulantExists: boolean = false;
  modalPostulant: boolean = false;

  constructor(
    private jobService: JobOfferService,
    private route: ActivatedRoute,
    private router: Router,
    private postulantService: JobOfferPostulantService,
    private tokenStorage: TokenStorageService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const jobId = params.get('id');
      if (jobId) {
        this.checkIfPostulantExists(jobId);

        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.isLoading = true;
        this.jobService.getJobDetailById(jobId).subscribe({
          next: (res) => {
            this.jobDetail = res.dto.jobOffer;
            this.isLoading = false;
            if (this.jobDetail?.publicationStatus === 'Publicado') {
              setTimeout(() => {
                this.jobService.registrarVisita(jobId).subscribe({
                  error: (err) => {
                    this.toastService.showMessages('error', [
                      MESSAGES.GENERAL.UNKNOWN_ERROR,
                    ]);
                  },
                });
              }, 30000);
            }
          },
          error: (err) => {
            this.isLoading = false;
          },
        });
      }
    });
  }

  goToJob(id: string) {
    this.router.navigate(['/job', id]);
  }

  postulate() {
    const auth = this.tokenStorage.getAuth();

    if (!auth) {
      console.log(auth);
      this.toastService.showMessages('warning', [MESSAGES.AUTH.UNAUTHORIZED]);
      return;
    }

    if (auth.status == UserStatus.INCOMPLETE) {
      this.toastService.showMessages('warning', [
        MESSAGES.AUTH.PROFILE_ICOMPLETE,
      ]);
      return;
    }

    this.isLoadingPostulant = true;

    this.postulantService
      .postulate(this.jobDetail?.idJobOffer || '')
      .subscribe({
        next: (res) => {
          if (res.type === 'success') {
            this.toastService.showMessages('success', [
              MESSAGES.POSTULANT.APPLY_SUCCESS,
            ]);
            this.postulantExists = true;
          } else {
            res.listMessage.forEach((msg) =>
              this.toastService.showMessages('error', [msg])
            );
          }
          this.isLoadingPostulant = false;
          this.closeModalPostulate();
        },
        error: (err) => {
          const messages = err?.error?.listMessage;
          this.toastService.showMessages('error', [
            messages || MESSAGES.POSTULANT.APPLY_ERROR,
          ]);
          this.isLoadingPostulant = false;
          this.closeModalPostulate();
        },
      });
  }

  openModalPostulate() {
    this.modalPostulant = true;
  }

  closeModalPostulate() {
    this.modalPostulant = false;
  }

  companyImage(): string {
    if (!this.jobDetail) {
      return APP_CONSTANTS.DEFAULT_IMAGE_COMPANY;
    }
    const url = this.jobDetail.company.urlBannerMiniPage;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_IMAGE_COMPANY;
    }
    return url;
  }

  checkIfPostulantExists(jobId: string) {
    this.postulantExists = false;
    const auth = this.tokenStorage.getAuth();

    if (!auth) {
      this.postulantExists = false;
      return;
    }

    this.postulantService.checkIfPostulantExists(jobId).subscribe({
      next: ({ dto }) => (this.postulantExists = dto.exists),
      error: () => (this.postulantExists = false),
    });
  }

  companyBanner(): string {
    if (!this.jobDetail) {
      return APP_CONSTANTS.DEFAULT_BANNER_COMPANY;
    }
    const url = this.jobDetail.company.urlBannerMvv;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_BANNER_COMPANY;
    }
    return url;
  }
}
